
import { Component, OnInit, ViewChild, NgModule } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { RRFormService } from '../r-r-form.service';
import { SelectablesService } from '../selectables.service';
import { ConsignorService } from '../_services/_masters/consignor.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { Subject } from 'rxjs';

import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ViewEncapsulation } from '@angular/core';
// import * as $ from 'jquery';
declare var $ : any;
import 'bootstrap';
import { DataTableDirective } from 'angular-datatables';
import swal from 'sweetalert2';
import { ProductService } from '../_services/_masters/product.service';
import { BranchMasterService } from '../_services/_masters/branch-master.service';
import { NgxSpinnerService } from 'ngx-spinner';

const user_info = JSON.parse(localStorage.getItem('currentUser'));
const headers = new Headers({'Content-Type': 'application/json','Authorization': JSON.parse(localStorage.getItem("user_token"))});
const options = new RequestOptions({ headers: headers });
const now = new Date();
class RRForm {
	rr_number:string;
	weight:string;
	qty_bags : string;
	rr_weigth: string;
	rr_date: Date;
	consignor: string;
	product: string;
	loading: string;
	station: string;
}

@Component({
	selector: 'app-r-r-form',
	templateUrl: './r-r-form.component.html',
	styleUrls: ['./r-r-form.component.css']
})

export class RRFormComponent implements OnInit {

	rRForm : FormGroup;
	modalRRForm :FormGroup;

	check_branch: boolean = true;

private url1 = environment.url;
	private branchUrl =  this.url1 + '/branch/all';
	private clientUrl =  this.url1 + '/clients/all';

	modalData:any;
	selected_branch_name="";

	stations : string[] =[];
	products : string[] = [];
	consignors: any[] = [];
	rr_number: any[] = [];

	advance_info_flag : boolean = false;
	rr_saved : boolean = false;
	last_rr_number="";
	product_package=[];
	get_product_package:any;

	bsConfig: Partial<BsDatepickerConfig>;

 
	// dtOptions: DataTables.Settings = {};
	dtOptions: any = {};
	dataTable: any;
	rrform: RRForm[] = [];
	// We use this trigger because fetching the list of persons can be quite long,
	// thus we ensure the data is fetched before rendering
	dtTrigger: Subject<any> = new Subject();
	@ViewChild(DataTableDirective)
	dtElement: DataTableDirective;

	loadPoint :any;
	selected_branch:string;
	selected_client:string;
	

	date: {year: number, month: number};
	displayMonths = 2;

	model;
	model2;
	model3
		branch;
	message :any;
	url = environment.url;

	rr_date:Date=new Date(Date.now());

	response :any = null;
	product_weight : string = null;
	modal_product_weight : string = null;
	//public dpConfig: Partial<BsDatepickerConfig> = new BsDatepickerConfig();

	constructor(
		private rrService: RRFormService, 
		private selectClientService : SelectablesService, 		 
		private http: Http,
		private selectablesService : SelectablesService,
		private router : Router,
		private route: ActivatedRoute,
		private selectConsignorService : ConsignorService,
		private selectProductService : ProductService,
		private selectBranchService : BranchMasterService,
		private spinner: NgxSpinnerService
		) {

			// this.route.queryParams.subscribe(params => {
	 //          	alert(params["firstname"]);
	 //      	});

		 }
	ngOnInit() 
	{
		this.loadPoint = this.getSelectedLoadingPoint()
		this.selected_branch = this.selectablesService.selected_branch;
		this.selected_client = this.selectablesService.selected_client;
		//alert(this.selected_client);
		//this.selected_client = this.consignors;
		this.rRForm = new FormGroup({

			'station': new FormControl(this.selected_branch, Validators.required),
			'consignor' : new FormControl(this.selected_client, Validators.required),
			'inv_prefix': new FormControl(null),
			'product' : new FormControl(null, Validators.required),
			'loading' : new FormControl(this.loadPoint, Validators.required),
			'rr_date': new FormControl(null, Validators.required),
			'qty_bags':  new FormControl(null),
			'rr_weight': new FormControl(this.product_weight),
			'weight': new FormControl(null),
			'rr_number': new FormControl(null),
			'rack_rr_number' : new FormControl(null)
		});
		if(user_info["role"] != "Admin"){
			this.rRForm.patchValue({
				"station" : user_info["branch"]
			});
		}
		

		this.modalRRForm = new FormGroup({
			'station': new FormControl(null, Validators.required),
			'consignor' : new FormControl(null, Validators.required),
			'inv_prefix': new FormControl(null),
			'product' : new FormControl(null, Validators.required),
			'loading' : new FormControl(null, Validators.required),
			'rr_date': new FormControl(null, Validators.required),
			'qty_bags':  new FormControl(null),
			'rr_weight': new FormControl(null),
			'rr_number': new FormControl(null),
			'weight': new FormControl(null),
			'rack_rr_number' : new FormControl(null)
		});

		this.bsConfig = Object.assign({}, { containerClass: 'theme-default' });

		this.dtOptions = {
				pagingType: 'full_numbers',
				pageLength: 5,
				responsive: true,
				ordering : false,
				// select:true,
				rowCallback: (row: Node, data: any[] | Object, index: number) => {
					const self = this;
					// Unbind first in order to avoid any duplicate handler
					// (see https://github.com/l-lin/angular-datatables/issues/87)
					$('td', row).unbind('click');
					$('td', row).bind('click', () => {
						self.someClickHandler(data);
					});
					return row;
				},
				dom: 'Bfrtip',
				// Configure the buttons
				buttons: [
					// 'columnsToggle',
					'colvis',
					'copy',
					'print',
					'excel'
				]
			};
			this.http.get(this.url + '/rrform/all', options)
				.map(this.extractData)
				.subscribe(forms => {
					this.rrform = forms;
					console.log(this.rrform);
					// Calling the DT trigger to manually render the table
					this.dtTrigger.next();
				});
			
		
		var myObject = localStorage.getItem('currentUser');
		var temp = JSON.parse(myObject);	
		if(localStorage.getItem('currentUser'))
		{
			if (temp["role"] === 'Admin')
			{
				this.getBranch();
				this.getConsignorBySelectedBranch(null);
				this.check_branch = false;
			}
			else if(temp['role'] === 'Manager' || temp['role'] === 'Employee')
			{
					this.rRForm.get('station').setValue(temp['branch']);
					this.stations.push(temp['branch']);
				this.getConsignorBySelectedBranch(temp['branch']);
				this.check_branch = true;
			}
		}
		// if(this.route.snapshot.paramMap.get('branch'))
		if(this.selected_branch)
		{
			this.getConsignorBySelectedBranch(this.selected_branch);			
		}

		this.loadAllAutoComplete();
		
		
	}

	getBranch()
		{
			this.selectBranchService.getBranches()
		.subscribe(
			branches => {
				for(var i=0;i<branches.length;i++)
				{
					this.stations.push(branches[i]['branch_name']);
				}
			});
		}
		getProductQty(product_weight)
		{
			
			console.log(this.product_weight);
			let get_product_qty = product_weight.target.value*1000/this.get_product_package;
			if (!isNaN(get_product_qty))
			{
				this.rRForm.get('qty_bags').setValue(get_product_qty);
				this.modalRRForm.get('qty_bags').setValue(get_product_qty);
			}
			else
			{
				this.rRForm.get('qty_bags').setValue("");
				this.modalRRForm.get('qty_bags').setValue("");
			}
			this.rRForm.patchValue({
				"rr_weight" : this.product_weight
			})
			this.modalRRForm.patchValue({
				"rr_weight" : this.modal_product_weight
			})
		}
		getProductWeight(product_qty)
		{	
			let get_product_weight = product_qty.target.value*this.get_product_package/1000;
			if (!isNaN(get_product_weight))
			{
				this.rRForm.get('weight').setValue(get_product_weight);
				this.modalRRForm.get('weight').setValue(get_product_weight);
			}
			else
			{
				this.rRForm.get('weight').setValue("");
				this.modalRRForm.get('weight').setValue("");
			}

			$('#product_weight').keyup();
			this.rRForm.patchValue({
				"rr_weight" : this.product_weight
			})
			this.modalRRForm.patchValue({
				"rr_weight" : this.modal_product_weight
			})

			$('#product_weight').keyup();
		}

		getProductPacking(product_name)
		{
			if(product_name)
			{
				this.get_product_package = this.product_package.find( x => x.product_name == product_name).packing;
			}
		}
		getConsignor()
		{
			this.selectConsignorService.getAllConsignor()
		.subscribe(
			consignors => {
				for(var i=0;i<consignors.length;i++)
				{
					if (this.consignors.includes(consignors[i]['consignor_name'])){

					}
					else{
						this.consignors.push(consignors[i]['consignor_name']);
					}
				}
			});
		}
		getConsignorBySelectedBranch(branch)
		{	
			console.log(user_info["branch"])
			if (branch == null){
				branch=user_info["branch"];
				console.log(user_info["branch"])
			}
			else{
				this.selected_branch_name=branch;
			}
			
			console.log(branch);
			this.consignors=[];
			this.selectConsignorService.getConsignorFormWithBranch(branch)
			.subscribe(
				consignors => {
					//alert(consignors);
					
					for(var i=0;i<consignors.length;i++)
					if (this.consignors.includes(consignors[i]['consignor_name'])){

					}
					else{
						this.consignors.push(consignors[i]['consignor_name']);
					}
				}
			);
		}
		getProductBySelectedClient(client)
		{

			this.getLastRRNumber(client);
			this.products=[];
			this.selectProductService.getProductByClientName(client)
		.subscribe(
			products => {
				for(var i=0;i<products.length;i++)
				{
					this.products.push(products[i]['product_name']);
					this.product_package.push(products[i]);
				}
			});
		}
		
		getProductAndTableBySelectedClient(client)
		{
			this.getProductBySelectedClient(client)
			this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
				dtInstance.destroy();
				this.http.get(this.url + '/rrform/get/branchandclient/'+this.selected_branch_name+'/'+client, options)
					.map(this.extractData)
					.subscribe(forms => {
					this.rrform = forms;
					// Calling the DT trigger to manually render the table
					this.dtTrigger.next();
				});
			});

		}
		getLastRRNumber(client)
		{
			this.last_rr_number="";
			this.rrService.getLastRRNumber(client)
		.subscribe(
			lastrrnumber => {
				this.last_rr_number = lastrrnumber.toString();
			});
		}
		
	rRSave(){ 
		//this.rRForm.get('station').enable();
		this.rr_saved = true; 
		console.log(this.rRForm.value);
		this.spinner.show();
		this.rrService.addNewRR(JSON.stringify(this.rRForm.value))
		.subscribe(response => {
			console.log(response);
			if(response['status'])
			{
				//this.rRForm.get('station').disable();
				swal('Save', 'Record save successfully', 'success');
				this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
					dtInstance.destroy();
					this.http.get(this.url + '/rrform/all', options)
						.map(this.extractData)
						.subscribe(forms => {
						this.rrform = forms;
						console.log(this.rrform);
						// Calling the DT trigger to manually render the table
						this.dtTrigger.next();
					});
				this.spinner.hide();
				})
				this.reset();
			}
		},error =>{
			this.spinner.hide();
			swal('Opps!', 'Something went wrong', 'error');
		});
		console.log(this.rRForm.value);
	};

	private extractData(res: Response) {
		const body = res.json();
		console.log(body.data || {});
		return body;

	};
	someClickHandler(info: any): void {
		this.rrService.getRRFormWith(info[0])
		.subscribe(response => {
			console.log('aaaaa'+JSON.stringify(response))
			this.modalData = JSON.stringify(response)
			this.modalData =JSON.parse(this.modalData)
			// console.log(this.modalData[0].basic_info.product);
			this.modalRRForm.patchValue({
				"consignor": this.modalData[0].consignor,
				"loading": this.modalData[0].loading,
				"station": this.modalData[0].station,
				'product': this.modalData[0].product,
				"qty_bags": this.modalData[0].qty_bags,
				"weight": this.modalData[0].weight,
				"rr_weight": this.modalData[0].rr_weight,
				"rr_number": this.modalData[0].rr_number,
				"date": this.modalData[0].date,
				"rack_rr_number": this.modalData[0].rack_rr_number
			});
		});	
		$("#default-modal").modal('show');
	};

	getSelectedLoadingPoint(){
		var point = this.selectablesService.selected_loading_point;
		if (point == 'rail'){
			return "By Rail";
		}
		else {
			return "By Godown";
		}
	};

	createGP(){
		this.selectablesService.getSelectedLoadPoint(this.modalData[0].loading);
		this.selectablesService.getRRNumber(this.modalData[0].rr_number);
		this.selectablesService.getRRDate(this.modalData[0].rr_date);
		this.selectablesService.getSelectedBranch(this.modalData[0].station);
		this.selectablesService.setConsigner(this.modalData[0].consignor);
		$("#default-modal").modal('toggle');
		this.router.navigate(['gatepass']);
		localStorage.setItem('form_info', JSON.stringify({
			'rr_number': this.modalRRForm.get('rr_number').value,
			'station': this.modalRRForm.get('station').value,
			'consignor' : this.modalRRForm.get('consignor').value,
			'loading' : this.modalRRForm.get('loading').value,
			'product' : this.modalRRForm.get('product').value,
		}));
	};

	createLR(){
		this.selectablesService.getSelectedLoadPoint(this.modalData[0].loading);
		this.selectablesService.getRRNumber(this.modalData[0].rr_number);
		this.selectablesService.getRRDate(this.modalData[0].rr_date);
		this.selectablesService.getSelectedBranch(this.modalData[0].station);
		this.selectablesService.setConsigner(this.modalData[0].consignor);
		localStorage.setItem('form_info', JSON.stringify({
			'rr_number': this.modalRRForm.get('rr_number').value,
			'station': this.modalRRForm.get('station').value,
			'consignor' : this.modalRRForm.get('consignor').value,
			'loading' : this.modalRRForm.get('loading').value,
			'product' : this.modalRRForm.get('product').value,
		}));

		$("#default-modal").modal('toggle');
		this.router.navigate(['lrform']);

	};

	updateRR(){
		console.log(this.modalRRForm.value);
		this.http.post( this.url + "/rrform/update", this.modalRRForm.value,options)
		.subscribe(res => { 
			console.log(res.json());
			this.response = res.json();
			console.log(this.response);
			console.log(this.response.status);
			if (this.response.status){

				if (this.response.message === 'RR Updated Successfully'){
					swal(
						' Success',
						'RR Form Updated Successfully',
						'success'
					);
				}

				if (this.response.message === 'RR Information not Changed'){
					swal(
						' Info ',
						'RR information not changed',
						'info'
					);
				}
			}
			else{
				if (this.response.message == "Gate-Pass or LR has been generated using this RR number"){
					swal(
						' RR Update Not Permitted',
						'Gate-Pass or LR has been generated using this RR number',
						'warning'
					);
				}
				else{
					swal(
						' Acknowledge Failed',
						'Please enter a RR number',
						'error'
					);
				}	
			}
			
		});
	};

	deleteRR(){
		console.log(this.modalRRForm.value);
		this.http.post( this.url + "/rrform/check/delete", this.modalRRForm.value, options)
		.subscribe(res => { 
			console.log(res.json());
			this.response = res.json();
			if (this.response["status"]) {
				swal({
					title: 'Are you sure?',
					text: "You won't be able to revert this!",
					type: 'warning',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: 'Yes, delete it!'
				}).then((result) => {
					if (result.value) {
						this.http.post( this.url + "/rrform/delete", {"rr_number" :this.modalRRForm.get('rr_number').value}, options)
						.subscribe(res => {
							console.log(res.json());
							var feedback = res.json();
							if (feedback.status){
								$("#default-modal").modal('hide');
								swal(
									'Deleted!',
									'Your RR has been deleted.',
									'success'
								);
								this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
									dtInstance.destroy();
									this.http.get(this.url + '/rrform/all', options)
										.map(this.extractData)
										.subscribe(forms => {
										this.rrform = forms;
										console.log(this.rrform);
										// Calling the DT trigger to manually render the table
										this.dtTrigger.next();
									});
								})
							}
						});
					}
				})
			}
			else{
				if (this.response.message = "RR is Present in GP and LR"){
					swal(
						'Failed!',
						'This RR number is used for Gate-pass and LR receipts.',
						'error'
					)
				}
				else if (this.response.message = "RR is Present in GP only"){
					swal(
						'Failed!',
						'This RR number is used for Gate-pass receipts.',
						'error'
					)
				}
				else if (this.response.message = "RR is Present in LR only"){
					swal(
						'Failed!',
						'This RR number is used for LR receipts.',
						'error'
					)
				}
				else{
					swal(
						'Failed!',
						'RR deleting Failed',
						'error'
					)
				}
			}

		});
	};

	reset(){
		this.rRForm.reset();
	};

	loadAllAutoComplete(){
		this.getConsignorBySelectedBranch(this.rRForm.get('station').value);
		this.getProductAndTableBySelectedClient(this.rRForm.get('consignor').value);
	}



}



// WEBPACK FOOTER //
// /Users/meghneel/work/shree_translogic_dashboard/src/app/r-r-form/r-r-form.component.ts